export default __webpack_public_path__ + "static/media/retur-kasir.46aa57d8.png";